let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3OT1S")).then(() => parcelRequire('jLwH2'));